import styled from '@emotion/styled';

export const SDangerActionItem = styled.div`
  color: #ff4d4f;
`;

export const SStatusCell = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const SFooter = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const SFormInput = styled.div`
  & .custom-ant-typography {
    display: block;
    margin-bottom: 8px;
  }
`;
